import React from 'react';
import { CardBody } from 'reactstrap';
// TODO make this reusable and apply it to menu-screen products(discount cards maybe too) and any future cards
const ItemCard = props => {

    return <CardBody style={{ padding: '0 5px 0 0' }}></CardBody>
}

export default ItemCard;